import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/Login.vue'),
    meta: { requiresAuth: false, title: '登录' },
  },
  {
    path: '/',
    component: () => import('@/layouts/AdminLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: '/import',
      },
      {
        path: 'import',
        name: 'Import',
        component: () => import('@/pages/Import.vue'),
        meta: { title: '工资单导入', icon: 'UploadOutlined' },
      },
      {
        path: 'resource-pool',
        name: 'ResourcePool',
        component: () => import('@/pages/ResourcePool.vue'),
        meta: { title: '人员详情', icon: 'TeamOutlined' },
      },
      {
        path: 'rd-allocation',
        name: 'RdAllocation',
        component: () => import('@/pages/RdAllocation.vue'),
        meta: { title: '研发分配', icon: 'ExperimentOutlined' },
      },
      {
        path: 'project-allocation',
        name: 'ProjectAllocation',
        component: () => import('@/pages/ProjectAllocation.vue'),
        meta: { title: '项目分配', icon: 'ProjectOutlined' },
      },
      {
        path: 'vehicle-allocation',
        name: 'VehicleAllocation',
        component: () => import('@/pages/VehicleAllocation.vue'),
        meta: { title: '车型分配', icon: 'CarOutlined' },
      },
      {
        path: 'aftersales-allocation',
        name: 'AfterSalesAllocation',
        component: () => import('@/pages/AfterSalesAllocation.vue'),
        meta: { title: '售后分配', icon: 'CustomerServiceOutlined' },
      },
      {
        path: 'import-u8',
        name: 'ImportU8',
        component: () => import('@/pages/ImportU8.vue'),
        meta: { title: '数据导入U8', icon: 'ImportOutlined' },
      },
      {
        path: 'timesheet-detail',
        name: 'TimesheetDetail',
        component: () => import('@/pages/TimesheetDetail.vue'),
        meta: { title: '工时明细', icon: 'ScheduleOutlined' },
      },
    ],
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: () => import('@/pages/ChangePassword.vue'),
    meta: { requiresAuth: true, title: '修改密码' },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/pages/NotFound.vue'),
    meta: { requiresAuth: false, title: '页面不存在' },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, _from, next) => {
  const authStore = useAuthStore();
  authStore.initAuth();

  if (to.meta.requiresAuth !== false && !authStore.isAuthenticated) {
    next({ name: 'Login', query: { redirect: to.fullPath } });
    return;
  }

    if (to.name === 'Login' && authStore.isAuthenticated) {
      if (authStore.requiresPasswordChange) {
        next({ name: 'ChangePassword' });
        return;
      }
      next({ name: 'Import' });
      return;
    }

    if (to.name === 'ChangePassword' && !authStore.requiresPasswordChange && authStore.isAuthenticated) {
      next({ name: 'Import' });
      return;
    }

  document.title = `${to.meta.title || '薪资调配系统'} - 薪资调配系统`;

  next();
});

export default router;
